import React, { createContext, useReducer } from "react";
import { OverallStatusReducer } from "../reducers/OverallStatusReducer";

export const OverallStatusContext = createContext();

const OverallStatusContextProvider = (props) => {
  const overallStatus = {
    inducted: "",
    picked: "",
    stowed: "",
    staged: "",
    departed: "",
    problemSolve: "",
  };
  const [viewModel, dispatch] = useReducer(OverallStatusReducer, overallStatus);
  return (
    <OverallStatusContext.Provider value={{ viewModel, dispatch }}>
      {props.children}
    </OverallStatusContext.Provider>
  );
};

export default OverallStatusContextProvider;



// WEBPACK FOOTER //
// ./src/components/overallstatus/context/OverallStatusContext.js